// extracted by mini-css-extract-plugin
export default {"Loading":"PrivateRoute_Loading__zwaP4"};